import React, {useEffect} from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ViewportProvider } from './Components/Viewport'
import Skeleton from './Components/Skeleton';
import Home from "./Pages/Home";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import GetQuote from "./Pages/GetQuote";
import AdminDashboard from "./Pages/AdminDashboard";
import StaffLogin from "./Pages/StaffLogin";
import StaffPortal from "./Pages/StaffPortal";
import ProtectedRoute from "./Components/Auth/ProtectedRoute";
import StaffProtectedRoute from "./Components/Staff/StaffProtectedRoute";
import NoPage from "./Pages/NoPage";
import ScrollToTop from './ScrollToTop';
import './App.css';

const App = () => {
  useEffect(() => {
    window.history.scrollRestoration = 'manual'
  }, []);
  return (
    <BrowserRouter className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/staff-login" element={<StaffLogin />} />
        <Route path="/staff-portal" element={
          <StaffProtectedRoute>
            <StaffPortal />
          </StaffProtectedRoute>
        } />
        <Route path="/" element={<ViewportProvider>
          <Skeleton />
        </ViewportProvider>} >
          <Route index element={<Home />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="contact" element={<ContactUs />} />
          <Route path="getQuote" element={<GetQuote />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
